import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonUtil, MessageService, TablePage } from '@serengeti/serengeti-common';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SchedulerHistoryService {

  endPoint: string;
    
  constructor(private messageService: MessageService) {
    this.endPoint = CommonUtil.buildEndPoint(environment.serviceSchedulerEndPoint, 'task/history');
  }

  search(schedulerGroupId: string,
    fromDate = null,
    toDate = null,
    filter = '',
    sortItem = 'createdDate', sortOrder = 'asc',
    pageNumber = 0, pageSize = 10): Observable<TablePage> {

    const url = CommonUtil.buildEndPoint(this.endPoint, '/search');

    return this.messageService.query(url, new HttpParams()
    .set('scheduleGroupId', schedulerGroupId)
    .set('keyword', filter)
    .set('fromDate', fromDate)
    .set('toDate', toDate)
    .set('sortItem', sortItem)
    .set('sortOrder', sortOrder)
    .set('pageNumber', pageNumber.toString())
    .set('pageSize', pageSize.toString())
    );
  }

  list(filter = '',
    fromDate = null,
    toDate = null,
    sortItem = 'createdDate', sortOrder = 'asc',
    pageNumber = 0, pageSize = 10): Observable<TablePage> {

    const url = CommonUtil.buildEndPoint(this.endPoint, '/');

    return this.messageService.query(url, new HttpParams()
    .set('keyword', filter)
    .set('fromDate', fromDate)
    .set('toDate', toDate)
    );
  }

  get(id: string): Observable<any> {
    const url = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/');

    return this.messageService.query(url);
  }
}
